<template>
  <q-section v-bind="$attrs">{{ isIOS ? '【该活动与苹果公司无关，解释权归HiFun所有】' : '' }}</q-section>
</template>

<script setup lang="ts">
const isIOS = navigator.userAgent.includes('iPhone') || navigator.userAgent.includes('iPad')
</script>

<style scoped lang="scss"></style>
